export default "__VITE_ASSET__49eb19c9__"